import Button from '@berlitz/button'
import Select from '@components/Select'
import { Col } from 'react-styled-flexboxgrid'
import styled from 'styled-components'

export const StyledCol = styled(Col)`
  margin-bottom: ${({ theme }) => theme.space.lg};
`

export const CardSpan = styled.span`
  color: ${({ theme }) => theme.colors.brandSecondaryContrast};
`

export const EmptySpan = styled.span`
  color: ${({ theme }) => theme.colors.brandPrimary};
`

export const RecommendedBtn = styled(Button)`
  border: none;
  border-radius: 16px;
  height: ${({ theme }) => theme.layout.xs};
  line-height: 0;
  width: 136px;
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin-top: ${({ theme }) => theme.space.sm};
  padding: 6px 17px;
`

export const StyledSelect = styled(Select)``

export const ProgramSelect = styled.div`
  width: 100%;
  display: flex;
  align-items: baseline;
  background-color: ${({ theme }) => theme.colors.ui09};
  border-radius: ${({ theme }) => theme.radius.md};
  padding: ${({ theme }) => `${theme.space.sm} ${theme.space.md}`};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
  }
`

export const ProgramLabel = styled.div`
  white-space: nowrap;
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.brandPrimary};
  font-size: ${({ theme }) => theme.fontSize.sm};
  div {
    padding-right: ${({ theme }) => theme.space.xs};
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-bottom: ${({ theme }) => theme.space.xs};
  }
`

export const LessonCountWrapper = styled.div`
  white-space: nowrap;
  border-radius: ${({ theme }) => theme.radius.sm};
  border: ${({ theme }) => `1px solid ${theme.colors.brandPrimary}`};
  margin-left: ${({ theme }) => theme.space.xs};
  padding: ${({ theme }) => theme.space.xs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  background: ${({ theme }) => theme.colors.brandPrimaryContrast};
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-left: 0;
    margin-top: ${({ theme }) => theme.space.xs};
  }
`
